// Función para convertir texto a snake_case
export function toSnakeCase(text) {
    return text
        .toLowerCase()
        .replace(/[áàäâ]/g, 'a')
        .replace(/[éèëê]/g, 'e')
        .replace(/[íìïî]/g, 'i')
        .replace(/[óòöô]/g, 'o')
        .replace(/[úùüû]/g, 'u')
        .replace(/[ñ]/g, 'n')
        .replace(/[ç]/g, 'c')
        .replace(/[^a-z0-9]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '');
}

// Función para obtener valor por defecto según tipo de campo
export function getDefaultValue(type) {
    switch (type) {
        case "number": return "";
        case "text":
        case "textarea": return "";
        case "checkbox": return false;
        case "date": return null;
        default: return "";
    }
}

// Función para generar el estado inicial desde el molde
export function generateInitialState(template, profileTemplates = {}) {
    const state = {
        perfil: "estandar",
        sections: {},
        customSections: []
    };

    // Generar secciones base
    Object.entries(template).forEach(([sectionKey, sectionConfig]) => {
        state.sections[sectionKey] = {
        title: sectionConfig.title,
        icon: sectionConfig.icon,
        fields: {}
        };

        Object.entries(sectionConfig.fields).forEach(([fieldKey, fieldConfig]) => {
        state.sections[sectionKey].fields[fieldKey] = getDefaultValue(fieldConfig.type);
        });
    });

     // Secciones del perfil seleccionado (si las hay)
    const profileSections = (profileTemplates && typeof profileTemplates === 'object') ? profileTemplates : {};
    Object.entries(profileSections).forEach(([sectionKey, sectionConfig]) => {
        state.sections[sectionKey] = {
            title: sectionConfig.title,
            icon: sectionConfig.icon,
            fields: {}
        };
        Object.entries(sectionConfig.fields || {}).forEach(([fieldKey, fieldConfig]) => {
            state.sections[sectionKey].fields[fieldKey] = getDefaultValue(fieldConfig.type);
        });
    });


    return state;
}
